// Shopify New Customer Accounts - redirect-based auth
// Customers manage their accounts on the Shopify-hosted account page

export const SHOPIFY_ACCOUNT_URL = 'https://shopify.com/99299819863/account';
